/* eslint-disable */
import { createApp } from 'vue';
import App from './App.vue';
import store from '@/store';
import router from '@/router';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import PrimeVue from 'primevue/config';
import { locale } from '@/assets/locale-pt-br'
import moment from 'moment';
import 'moment/locale/pt-br';
import { MizunePreset, MizuneThemeOptions } from '@/theme/mizunePreset';
import '@/assets/styles.scss';
import InputNumber from 'primevue/inputnumber';
import InputText from "primevue/inputtext";
import AutoComplete from 'primevue/autocomplete';
import Checkbox from 'primevue/checkbox';
import ToggleSwitch from 'primevue/toggleswitch';
import Toolbar from 'primevue/toolbar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import DatePicker from 'primevue/datepicker';
import Button from 'primevue/button';
import SelectButton from 'primevue/selectbutton';
import Password from 'primevue/password';
import ConfirmDialog from 'primevue/confirmdialog';
import Dialog from 'primevue/dialog';
import Toast from 'primevue/toast';
import RadioButton from 'primevue/radiobutton';
import Menu from 'primevue/menu';
import TieredMenu from 'primevue/tieredmenu';
import Avatar from 'primevue/avatar';
import InputMask from 'primevue/inputmask';
import Tree from 'primevue/tree';
import FileUpload from 'primevue/fileupload';
import Textarea from 'primevue/textarea';
import Divider from 'primevue/divider';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Tooltip from 'primevue/tooltip';
import Ripple from 'primevue/ripple';
import Fieldset from 'primevue/fieldset';
import ScrollPanel from 'primevue/scrollpanel';
import Message from 'primevue/message';
import ProgressBar from 'primevue/progressbar';
import FloatLabel from 'primevue/floatlabel';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Panel from 'primevue/panel';
import Skeleton from 'primevue/skeleton';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import DataView from 'primevue/dataview';
import Badge from 'primevue/badge';
import OverlayBadge from 'primevue/overlaybadge';
import Tag from 'primevue/tag';
import Chip from 'primevue/chip';
import SplitButton from 'primevue/splitbutton';
import Image from 'primevue/image';
import ProgressSpinner from 'primevue/progressspinner';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import OrderList from 'primevue/orderlist';
import Select from 'primevue/select';
import IftaLabel from 'primevue/iftalabel';
import ColorPicker from 'primevue/colorpicker';
import Editor from 'primevue/editor';
import Card from 'primevue/card';
import ContextMenu from 'primevue/contextmenu';
import Chart from 'primevue/chart';


moment.locale('pt-br');

const app = createApp(App);

app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('AutoComplete', AutoComplete);
app.component('Checkbox', Checkbox);
app.component('ToggleSwitch', ToggleSwitch);
app.component('Toolbar', Toolbar);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('DatePicker', DatePicker);
app.component('Button', Button);
app.component('SelectButton', SelectButton);
app.component('Password', Password);
app.component('ConfirmDialog', ConfirmDialog);
app.component('Toast', Toast);
app.component('Dialog', Dialog);
app.component('RadioButton', RadioButton);
app.component('Menu', Menu);
app.component('TieredMenu', TieredMenu);
app.component('Avatar', Avatar);
app.component('InputMask', InputMask);
app.component('Tree', Tree);
app.component('FileUpload', FileUpload);
app.component('Textarea', Textarea);
app.component('Divider', Divider);
app.component('InputGroup', InputGroup);
app.component('InputGroupAddon', InputGroupAddon);
app.component('Fieldset', Fieldset);
app.component('ScrollPanel', ScrollPanel);
app.component('Message', Message);
app.component('ProgressBar', ProgressBar);
app.component('FloatLabel', FloatLabel);
app.component('IconField', IconField);
app.component('InputIcon', InputIcon);
app.component('Panel', Panel);
app.component('Skeleton', Skeleton);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('DataView', DataView);
app.component('Badge', Badge);
app.component('OverlayBadge', OverlayBadge);
app.component('Tag', Tag);
app.component('Chip', Chip);
app.component('SplitButton', SplitButton);
app.component('Image', Image);
app.component('ProgressSpinner', ProgressSpinner);
app.component('Tabs', Tabs);
app.component('TabList', TabList);
app.component('Tab', Tab);
app.component('TabPanels', TabPanels);
app.component('TabPanel', TabPanel);
app.component('OrderList', OrderList);
app.component('Select', Select);
app.component('IftaLabel', IftaLabel);
app.component('ColorPicker', ColorPicker);
app.component('Editor', Editor);
app.component('Card', Card);
app.component('ContextMenu', ContextMenu);
app.component('Chart', Chart);

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);


app.use(router)
app.use(PrimeVue, {
    locale,
    ripple: true,
    theme: {
        preset: MizunePreset,
        options: MizuneThemeOptions
    }
});
app.use(ConfirmationService)
app.use(ToastService)
app.use(store)

app.mount('#app');